import React, { useReducer } from 'react';
import firebase from "firebase/app";
import 'firebase/auth';

import { firestoreInitialize } from 'config/firebase/client';

import AuthenticationReducer from './AuthenticationReducer';
import AuthenticationContext from './AuthenticationContext';

const AuthenticationState = (props) => {
    const initialState = {
        getAuth: {
            isLogged: false,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        userLogged: {
            isLogged: null,
            user: {
                id: null,
                administradorId: null,
                nombre: null,
                apellido: null,
                email: null,
                emailVerified: null,
                avatar: null,
                role: null,
                pais: null,
                codigoPais: null,
                status: null,
                lastConnection: null,
                createdAt: null
            },
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        recoveryPassword: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        signOut: {
            loading: false,
            hasSuccess: false,
            hasError: false
        },
    };

    const [state, dispatch] = useReducer(AuthenticationReducer, initialState);

    const getAuthentication = (email, password) => {
        dispatch({ type: 'GET_AUTHENTICATION_LOADING' });

        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(() => dispatch({ type: 'GET_AUTHENTICATION' }))
            .catch(error => dispatch({ type: 'GET_AUTHENTICATION_ERROR', payload: error }))
    };

    const getAuthenticated = () => {
        dispatch({ type: 'GET_USER_AUTHENTICATED_LOADING' });

        let db = firestoreInitialize();

        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                let docRef = db.collection("Administradores")
                    .where('authId', '==', user.uid);

                docRef.get().then((documentSnapshot) => {
                    const userData = documentSnapshot.docs.map(doc => doc.data())
                    const userDataId = documentSnapshot.docs.map(doc => doc.id)

                    if (userData.length > 0) {
                        if (userData[0].administradorId) {
                            dispatch({ type: 'GET_USER_AUTHENTICATED', payload: { user: user, data: userData[0] } });
                        } else {
                            db.collection("Administradores").doc(userDataId[0]).update({
                                administradorId: userDataId[0]
                            })
                            .then(() => {
                                getAuthenticated();
                            })
                            .catch(() => {
                                authenticationSignOut();
                                dispatch({ type: 'GET_USER_AUTHENTICATED_ERROR', payload: { code: 'auth/not-logged', message: 'Could not get user data' } })
                            });
                        }
                    } else {
                        let docRefWithEmail = db.collection("Administradores")
                            .where('email', '==', user.email);

                        docRefWithEmail.get().then((documentSnapshot) => {
                            const userDataWithEmail = documentSnapshot.docs.map(doc => doc.data())
                            const userDataWithEmailId = documentSnapshot.docs.map(doc => doc.id)
                            
                            if (userDataWithEmail.length > 0) {
                                db.collection("Administradores").doc(userDataWithEmailId[0]).update({
                                    authId: user.uid,
                                    administradorId: userDataWithEmailId[0]
                                })
                                .then(() => {
                                    dispatch({ type: 'GET_USER_AUTHENTICATED', payload: { user: user, data: userDataWithEmail[0] } });
                                })
                                .catch(() => {
                                    firebase.auth().signOut();
                                    dispatch({ type: 'GET_USER_AUTHENTICATED_ERROR', payload: { code: 'auth/not-logged', message: 'Could not get user data' } })
                                });
                            } else {
                                firebase.auth().signOut();
                                dispatch({ type: 'GET_USER_AUTHENTICATED_ERROR', payload: { code: 'auth/not-logged', message: 'Could not get user data' } })
                            }
                        }).catch(() => {
                            firebase.auth().signOut();
                            dispatch({ type: 'GET_USER_AUTHENTICATED_ERROR', payload: { code: 'auth/not-logged', message: 'Could not get user data' } })
                        })
                    }
                });
            } else {
                dispatch({ type: 'GET_USER_AUTHENTICATED_ERROR', payload: { code: 'auth/not-logged', message: 'This user is not logged' } })
            };
        });
    };

    const authenticationSignOut = () => {
        dispatch({ type: 'SIGNOUT_USER_AUTHENTICATED_LOADING' });

        firebase.auth().signOut()
            .then(() => dispatch({ type: 'SIGNOUT_USER_AUTHENTICATED' }))
            .catch(() => dispatch({ type: 'SIGNOUT_USER_AUTHENTICATED_ERROR' }))
    };

    const recoveryPassword = (email) => {
        dispatch({ type: 'RECOVERY_PASSWORD_LOADING' });

        const actionCodeSettings = {
            url: `https://prioritypetpanel.web.app/?email=${email}`
        };

        firebase.auth().sendPasswordResetEmail(email, actionCodeSettings).then(function() {
            dispatch({ type: 'RECOVERY_PASSWORD' })
        }).catch((error) => {
            dispatch({ type: 'RECOVERY_PASSWORD_ERROR', payload: { code: error.code, message: error.message } })
        });
    };

    const authenticationResetState = () => {
        dispatch({ type: 'AUTHENTICATION_RESET_STATE' })
    };

    return (
        <AuthenticationContext.Provider value={{
            authenticationState: state.getAuth,
            authenticatedState: state.userLogged,
            recoveryPasswordState: state.recoveryPassword,
            signOutState: state.signOut,
            getAuthentication,
            getAuthenticated,
            authenticationSignOut,
            recoveryPassword,
            authenticationResetState
        }}>
            {props.children}
        </AuthenticationContext.Provider>
    )
}

export default AuthenticationState;